import React, { useState, lazy, Suspense, memo, useContext} from 'react';
import { SttTabs, SttTranslateHook, SttContainerTitle} from '@stt-componentes/core-v2';
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
    wrapper: {
        padding: theme.spacing(1)
    }
}));

const GestaoCredenciais = lazy(() => import('./gestao-credenciais/GestaoCredenciais'));

const GestaoCredenciaisSuspense = memo((props) => {
   return (
       <Suspense>
           <GestaoCredenciais {...props} />
       </Suspense>
   );
});

const IndexCredenciais = ({ props }) => {
   const { strings } = useContext(SttTranslateHook.I18nContext);
   const classes = useStyles();

   const abas = [
       {
            titulo: strings.gestaoCredenciais,
            conteudo: GestaoCredenciaisSuspense,
            key: 'GestaoCredenciaisSuspense',
            permanente: true,
       },
   ];

   const [abaAtiva, setAbaAtiva] = useState('0');

return (
    <SttTabs
        abas={abas}
        className={classes.wrapper}
        canClose={true}
        handleChangeAbaAtiva={setAbaAtiva}
        abaAtiva={abaAtiva}
        permanente={true}
        preload={false}
    />
);
};

export default IndexCredenciais;
